import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A man's straying eyes",
  "description": "",
  "published": "2009-03-31T00:00:00.000Z",
  "redirect_from": ["/blog/?p=474"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`talk about how when a man looks at another woman it's a vote for his`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      